
import BaseFirebaseRepository from './BaseFirebaseRepository';
import TemporaryTableQr from '../../Model/TemporaryTableQr';
import { StatusType } from '../../Model/Status';

const instances = {}
const defaultInstanceKey = Math.random()
export default class TemporaryTableQrRepository extends BaseFirebaseRepository {
    isUseAPI = false

    /**
     * @param {*} app
     * @return {TemporaryTableQrRepository}
     */
    static getInstance(app, isLoadByFirebase) {
        if (app == null) {
            // By default, use instance created from main App
            app = TemporaryTableQrRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new TemporaryTableQrRepository(app)
        }
        return instances[app]
    }

    /**
     * Return the Firebase query
     */
     getRef = () => {
        return firebase.database().ref(firebase_path + '/temporary_table_qrs/')
            .orderByChild('merchant_status')
            .equalTo(`${merchant_id}_${StatusType.ACTIVE}`)
    }
    getSingleRef = () => {
        return firebase.database().ref(firebase_path + '/temporary_table_qrs/')
        .orderByChild("id")
    }

    getBaseObject = () => {
        return new TemporaryTableQr()
    }

    getReloadEventKey = () => {
        return "temporary_table_qrs.changed"
    }

    getApiBaseUrl = (id) => {
        return '/merchant/api/temporary_table_qr'
    }

    getTemporaryQrForTable = (tableId) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/table/${tableId}/temporary_table_qr/list`,
                success : (res) => {
                    if (Array.isArray(res)) {
                        resolve(res.map(item => {
                            return Object.assign(this.getBaseObject(), item)
                        }))
                    }
                    else {
                        resolve([Object.assign(this.getBaseObject(), res)])
                    }
                }
            })
            .fail(() => {
                reject("Failed to load temporary table qr.")
            })
        })
    }
    deactivate = (id) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url     : `/merchant/api/temporary_table_qr/${id}/deactivate`,
                type    : 'post',
                success : (res) => {
                    if (Array.isArray(res)) {
                        resolve(res.map(item => {
                            return Object.assign(this.getBaseObject(), item)
                        }))
                    }
                    else {
                        resolve([Object.assign(this.getBaseObject(), res)])
                    }
                }
            })
            .fail(() => {
                reject("Failed to load deactivate table qr.")
            })
        })
    }
}